import axios from "../base/axios.js";

const baseUrl = '/longstron/material/supplier';

// 获取枚举类
export function getByEnumClass(ids) {
  return axios.post(baseUrl + '/getByEnumClass', { ids });
}

// 获取材料子系统
export function getSubsystem() {
  return axios.post("/longstron/material/category/getSubsystem", { pagination: false });
}

// 获取字典
const dictObj = {};
export async function getByDictKey(dictKey, limit = { pagination: false, enabled: true }, params) {
  if (dictObj[dictKey]) return dictObj[dictKey];
  else {
    const res = await axios.post("/longstron/setting/dictionary/getByDictKey/" + dictKey, limit, { params });
    dictObj[dictKey] = res;
    return res;
  }
}

// 获取品牌列表
export function brandQuery(limit, params) {
  return axios.post("/longstron/material/brand/list", limit, { params });
}

/**
 * @description: 获取区域数据
 * @param {Object} limit 参数条件，{ areaName, provinceId, hasProvince, hasCity }
 * @param {Object} params params参数
 */
export function listDistrict(limit, params) {
  return axios.post("/longstron/setting/district/listDistrict/whitelist", limit, { params });
}

/**
 * @description: 获取省/市集合
 * @param {String} areaId 区域id
 * @param {Boolean} hasCity 是否有市级子数据
 * @param {Object} params params参数
 */
export function queryProvinceList(areaId, hasCity, params) {
  return listDistrict({
    areaName: areaId,
    hasProvince: true,
    hasCity: hasCity,
  }, Object.assign({
    loading: true
  }, params))
}

/**
 * @description: 查询市列表
 * @param {String} provinceId 省id
 * @param {Object} params params参数
 */
export function queryCityList(provinceId, params) {
  return listDistrict({
    provinceId: provinceId
  }, Object.assign({
    loading: true
  }, params))
}

export function supplierAddModel(data) {
  return axios.post(baseUrl, data);
}

/**
 * @description: 根据供应商id获取清单(联系人)
 * @param {String} id 供应商id
 */
export function getLinkmanById(id, limit) {
  return axios.post("/longstron/material/supplier/linkman/listBySupplierId/" + id, limit);
}

export function getBrandBySubsystem(id) {
  return axios.post("/longstron/material/brand/category/listByCatagoryId/"+ id);
}

/**
 * @description: 获取品牌列表
 * @param {Object} limit 搜索分页等限制参数
 */
export function getBrandList(limit) {
  return axios.post("/longstron/material/brand/list", limit);
}

export function addBrandBySubsystem(limit) {
  return axios.post("/longstron/material/brand/category/syncBrandCatagory", limit);
}

/**
 * @description: 新增数据
 * @param {Object} model 数据模型
 */
export function productAddModel(model) {
  return axios.post(baseUrl + '/product/system', model);
}

/**
 * @description: 根据id编辑数据
 * @param {Object} model 数据模型
 */
export function productEditModel(model) {
  return axios.put(baseUrl + '/product/system/' + model.id, model);
}

/**
 * @description: 根据id删除数据
 * @param {String} id id
 */
export function productDeleteModel(id) {
  return axios.delete(baseUrl + '/product/system/' + id);
}

/**
 * @description: 供应链首页统计值
 */
export function getDataCount(id) {
  return axios.get(baseUrl + '/getDataCount/' + id);
}
